import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumFinanceCheckTranslate',
  standalone: true,
})
export class FinanceCheckTranslatePipe implements PipeTransform {
  transform(value: string | null | undefined, enumObj: Record<string, string>): string {
    if (!value) return '-';

    const values: string[] = value.includes(',') ? value.split(',').map((v: string): string => v.trim()) : [value];

    return values
      .filter((v: string): boolean => !!v)
      .map((v: string): string => enumObj[v] ?? v)
      .join(', ');
  }
}
